import { Shield, Clock, Award, Wrench, Phone, Building2, HardHat, Tractor } from 'lucide-react';

export const servicesList = [
  {
    title: 'Pipe Fencing',
    description: 'Heavy-duty 2-3/8" drill pipe fencing built to withstand Texas weather and livestock pressure.',
    icon: Shield,
    link: '/services/pipe-fence-installation'
  },
  {
    title: 'Custom Gates',
    description: 'Custom entry gates designed and built specifically for your property.',
    icon: Award,
    link: '/services/custom-gates'
  },
  {
    title: 'Farm & AG',
    description: 'Livestock pens, cattle working facilities, sorting alleys, and complete ranch infrastructure.',
    icon: Tractor,
    link: '/services/farm-ag'
  },
  {
    title: 'Concrete Services',
    description: 'Driveways, patios, shop slabs, barn floors, RV pads, stamped & decorative concrete.',
    icon: HardHat,
    link: '/services/concrete-contractors-fort-worth'
  },
  {
    title: 'Shops & Buildings',
    description: 'Custom metal shops, patio covers, outdoor kitchens, and concrete slab work.',
    icon: Building2,
    link: '/services/shops-buildings'
  },
  {
    title: 'Mobile Welding',
    description: 'On-site mobile welding services for your convenience.',
    icon: Wrench,
    link: '/services/mobile-welding'
  },
  {
    title: 'Ranch Fencing',
    description: 'Top rail, no-climb wire, and complete ranch fencing solutions.',
    icon: Shield,
    link: '/services/ranch-fence'
  }
];

export const galleryImages = [
  {
    url: '/images/welding-services.jpg',
    alt: 'Professional Welding Services North Texas',
    title: 'Expert Welding'
  },
  {
    url: '/images/pipe-fence-installation.jpg',
    alt: 'Pipe Fence Installation',
    title: 'Professional Installation'
  },
  {
    url: '/images/quality-craftsmanship.jpg',
    alt: 'Professional Welding Work',
    title: 'Quality Craftsmanship'
  },
  {
    url: '/images/wire-mesh-fencing.jpg',
    alt: 'Wire Mesh Fencing Installation with Church Background',
    title: 'Professional Fence Installation'
  },
  {
    url: '/images/black-pipe-fencing.jpg',
    alt: 'Black Pipe Fencing Installation',
    title: 'Pipe Fence Installation'
  },
  {
    url: '/images/no-climb-wire-fencing.jpg',
    alt: 'No-Climb Wire Fencing',
    title: 'No-Climb Fencing'
  },
  {
    type: 'video',
    url: '/images/project-compilation.mp4',
    alt: 'Project Compilation Video',
    title: 'Projects Showcase'
  },
  {
    type: 'video',
    url: '/images/project-video-1.mp4',
    alt: 'North Texas Welding Project',
    title: 'NTX Field Work'
  },
  {
    type: 'video',
    url: '/images/project-video-2.mp4',
    alt: 'Property Improvement Project',
    title: 'On-Site Build'
  }
];

export const values = [
  { icon: Award, title: 'Quality Craftsmanship', desc: 'Clean welds, straight lines, professional installations' },
  { icon: Clock, title: 'On-Time Completion', desc: 'We respect your time and deliver when promised' },
  { icon: Shield, title: 'Built to Last', desc: 'Decades of durability, not just years' },
  { icon: Phone, title: 'Clear Communication', desc: 'Honest pricing and transparent updates' }
];

export const certifications = [
  { title: 'Licensed & Insured', desc: 'Fully licensed welding contractor with comprehensive liability insurance' },
  { title: 'AWS Certified Welders', desc: 'American Welding Society certified professionals' },
  { title: '15+ Years Experience', desc: 'Serving North Texas since 2009' },
  { title: '500+ Projects Completed', desc: 'Residential, ranch, and commercial installations' }
];

export const guarantees = [
  { title: '5-Year Workmanship Warranty', desc: 'We guarantee our installation quality for 5 years' },
  { title: '10-Year Material Warranty', desc: 'Premium materials backed by manufacturer warranties' },
  { title: 'Free Estimates', desc: 'No-obligation quotes with transparent pricing' },
  { title: 'Satisfaction Guaranteed', desc: 'We don\'t leave until you\'re 100% satisfied' }
];

export const testimonials = [
  {
    name: 'Mike Thompson',
    location: 'Springtown, TX',
    project: 'Pipe Fence Installation',
    rating: 5,
    text: 'Outstanding work! They installed 800 feet of pipe fence on our ranch. Clean welds, straight lines, and finished ahead of schedule. Highly recommend for anyone needing quality fencing.',
    date: 'January 2026'
  },
  {
    name: 'Sarah Martinez',
    location: 'Weatherford, TX',
    project: 'Custom Ranch Gate',
    rating: 5,
    text: 'Built us a beautiful 16-foot custom gate with our ranch name. The craftsmanship is incredible and it operates so smoothly. Worth every penny!',
    date: 'December 2025'
  },
  {
    name: 'John Davidson',
    location: 'Parker County, TX',
    project: 'Ranch Fencing - 150 Acres',
    rating: 5,
    text: 'Fenced our entire 150-acre property. Professional crew, fair pricing, and the fence looks fantastic. These guys know what they\'re doing.',
    date: 'November 2025'
  },
  {
    name: 'Robert Chen',
    location: 'Granbury, TX',
    project: 'Mobile Welding Service',
    rating: 5,
    text: 'Emergency trailer repair - they came out same day and had us back on the road in hours. Professional service and reasonable prices.',
    date: 'February 2026'
  }
];
